import {
  PupilContext,
  Task,
  EventMovedInterface,
} from '@lyceo/shared/plan/util-models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PlanPageActions = createActionGroup({
  source: 'Plan Page',
  events: {
    'Init': emptyProps(),
    'Enter': emptyProps(),
    'Create New Task Clicked': emptyProps(),
    'Day List Task Clicked': props<{ task: Task }>(),
    'Todo Task Clicked': props<{ task: Task }>(),
    'Instructor Complete Task Clicked': props<{ task: Task; value: boolean }>(),
    'Pupil Complete Task Clicked': props<{
      task: Task;
      value: boolean;
      showReflection: boolean;
    }>(),
    'Active Date Changed': props<{ date: Date }>(),
    'Calendar Day Clicked': props<{ date: Date }>(),
    'Calendar Task Clicked': props<{ date: Date; task: Task }>(),
    'Today Button Clicked': emptyProps(),
    'Number Of Weeks Clicked': props<{ numberOfWeeks: number }>(),
    'Task Moved': props<{ moved: EventMovedInterface }>(),
    'Sync Elo Clicked': emptyProps(),
  },
});

export const PlanModuleActions = createActionGroup({
  source: 'Plan module',
  events: {
    'Pupil Context Changed': props<{
      pupilContext: PupilContext | undefined;
    }>(),
  },
});
